import { SignIn as ClerkSignIn } from "@clerk/clerk-react";
import { Box } from "@mui/material";

export default function SignIn() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ClerkSignIn />
    </Box>
  );
}
